module.exports = __webpack_public_path__ + "img/img3.1812cced.png";